import React from 'react';
import { Typography } from '@routific/hive/v5';
import { DateTime } from 'luxon';
import { defaultDisplayDateFormat } from '../../../../constants';
import OrderWarning, { OrderWarningType } from '../../OrderWarning';
import { InlineRow } from './styles';

interface Props {
  deliveryDate: string;
  isDateMismatched?: boolean;
}

const DeliveryDate: React.FC<Props> = ({ deliveryDate, isDateMismatched = false }) => {
  const dateTime = DateTime.fromISO(deliveryDate);

  if (!dateTime.isValid) {
    return null;
  }

  const formattedDeliveryDate = dateTime.toFormat(defaultDisplayDateFormat);

  return (
    <InlineRow>
      {isDateMismatched && (
        <OrderWarning types={[OrderWarningType.DATE_MISMATCH]} />
      )}
      <Typography
        variant="body"
        data-cy="order-details-content-delivery-date"
        data-testid="order-details-content-delivery-date"
      >
        {formattedDeliveryDate}
      </Typography>
    </InlineRow>
  );
};

export default DeliveryDate;
